
<div fxLayout="row wrap"  fxlayoutalign="center center" >
    <div fxFlex=90 fxFlex.gt-sm=34 fxFlexAlign="start"> 
        <div class="list-title" fxLayout="row" fxlayoutalign="space-around center"> 最新公告</div>
        <div *ngFor="let item of bulletinItems  ">
            <a href="{{item.link}}" target="_blank">
                <div class="hvr-bounce-to-right list-style">
                    <div>{{item.title}}</div>
                    <div fxLayout="row" fxlayoutalign="space-around center" class="list-res"><span fxFlex="30">公告單位：{{item.author}}</span> <span fxFlex="60">更新日期：{{item.pubDate}}</span></div>
                </div>
            </a>
        </div>
        <a href="https://groups.google.com/forum/#!forum/ccps-bulletin" target="_blank">
            <div fxLayout="row" fxLayoutAlign="center space-around" class="list-more hvr-outline-in">
            更多公告訊息
            </div>
        </a>
    </div>
    <div fxFlex=90 fxFlex.gt-sm=33 fxFlexAlign="start">
        <div class="list-title">最新榮譽榜</div>
        <div *ngFor="let item of honorItems">
            <a href="{{item.link}}" target="_blank">
                <div class="hvr-bounce-to-right list-style">
                    <div>{{item.title}}</div>
                    <div fxLayout="row" fxlayoutalign="space-around center" class="list-res"><span fxFlex="30">公告單位：{{item.author}}</span> <span fxFlex="60">更新日期：{{item.pubDate}}</span></div>
                </div>
            </a>
        </div>
        <a href="https://groups.google.com/forum/#!forum/ccps-honorroll" target="_blank">
            <div fxLayout="row" fxLayoutAlign="center space-around" class="list-more hvr-outline-in">
                更多榮譽榜獎項
            </div>
        </a>
    </div>

    <div fxFlex=90 fxFlex.gt-sm=33 fxFlexAlign="start">
        <div class="list-title">最新營隊消息</div>
        <div *ngFor="let item of campItems">
            <a href="{{item.link}}" target="_blank">
                <div class="hvr-bounce-to-right list-style">
                    <div>{{item.title}}</div>
                    <div fxLayout="row" fxlayoutalign="space-around center" class="list-res"><span fxFlex="30">公告單位：{{item.author}}</span> <span fxFlex="60">更新日期：{{item.pubDate}}</span></div>
                </div>
            </a>
        </div>
        <a href="https://groups.google.com/forum/#!forum/ccps-camp" target="_blank">
            <div fxLayout="row" fxLayoutAlign="center space-around" class="list-more hvr-outline-in">
                更多營隊消息
            </div>
        </a>
    </div>
</div>




